import { ObjectFieldTemplateProps } from "@rjsf/utils";

function MainImgTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
    
    <div className="cms-section">
        <h3>{props.title}</h3>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("img", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainImgTemplate;
